module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-wildfly-01-m.1d1aa8ad4fa25aa8a92791a2b2e3aed0.png";